const onlyNumbersRegexp = /^[0-9]+$/;

const onlyEnglishLetters = /^[a-z]+$/i;

const englishLettersAndNumbers = /^[A-Za-z0-9]*$/;

export { onlyNumbersRegexp, onlyEnglishLetters, englishLettersAndNumbers };
